import request from './axios';


// 精准估价
export function accurateValuation(data, token, partnerId) {
    return request({
        url: `${process.env.NPI_BASE_URL}/cheyipai/evaluation/app/evaluationAppApi/accurateValuation.json`,
        method: 'post',
        headers: {
            onlineId: token,
            partnerId
        },
        data: data,
    });
}
// 免费估价
export function freeEvaluation(data, token, partnerId) {
    console.log(process.env.NPI_BASE_URL)
    return request({
        url: `${process.env.NPI_BASE_URL}/cheyipai/evaluation/app/evaluationAppApi/freeEvaluation.json`,
        method: 'post',
        headers: {
            onlineId: token,
            partnerId
        },
        data: data,
    });
}
// 超二埋点
export function buryingPoint(data, token, partnerId) {
    console.log(process.env.NPI_BASE_URL)
    return request({
        url: `${process.env.DSC_BASE_URL}/base/operationLogApi/buryingPoint.json`,
        method: 'post',
        headers: {
            _security_token: token,
            partnerId
        },
        data: data,
    });
}
// 获取估价记录列表 http://cheyipai-evaluation.svc.test.suixinhuan.com/api#!/evaluation-app-api/getEvaluationRecordPage
export function getEvaluationRecordPage(data) {
    return request({
        url: `${process.env.NPI_BASE_URL}/cheyipai/evaluation/app/evaluationAppApi/getEvaluationRecordPage.json`,
        method: 'post',
        data: data,
    });
}

// 获取平台车源车列表 http://platform-auction-biz.svc.test.suixinhuan.com/api#!/auctionlistcontroller/getSimpleCarList
export function getSimpleCarList(data) {
    return request({
        url: `${process.env.NPI_BASE_URL}/auction/biz/auctionListController/getSimpleCarList.json`,
        method: 'post',
        data: data,
    });
}
// 获取平台车源车列表 http://platform-auction-biz.svc.test.suixinhuan.com/api#!/auctionlistcontroller/getSimpleCarList
export function carPriceMarket(data) {
    return request({
        url: `${process.env.CYP_BASE_URL}/valuateCarPrice/carPriceMarket`,
        method: 'post',
        data: data,
    });
}



// WEBPACK FOOTER //
// ./src/api/url.js